import styled from "@emotion/styled";

export const Spacer = styled.div`
  margin: 0px;
  box-sizing: border-box;
  padding: ${({ spacing }) => (!!spacing ? spacing : "0px")};
`;
